<template>
  <div class="nuttrema-layout-mobile-ready" :class="[`is-${display}`, theme ? `theme-${theme}` : '', { 'is-open': x !== 0 }]">

    <div class="nuttrema-layout-mobile-ready__side" ref="side" :style="sideStyle">
      <slot name="sidebar"></slot>
    </div>

    <div
       ref="content"
       class="nuttrema-layout-mobile-ready__content"
       v-touch:swipe.left="openSidebar"
       v-touch:swipe.right="closeSidebar">

      <div class="nuttrema-layout-mobile-ready__mask"></div>

      <div class="nuttrema-layout-mobile-ready__content__inside">
        <slide-transition>
          <slot></slot>
          <!-- <router-view></router-view> -->
        </slide-transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import { TimelineMax, Power4 } from 'gsap';
import * as EVENT from 'constants/event';

import SlideTransition from 'components/ui/transitions/slide-transition';
import ResponsiveMonitor from 'components/mixins/responsive-monitor';

Vue.use(Vue2TouchEvents);

export default {
  name: 'nuttrema-layout-mobile-ready',
  componentName: 'NuttremaLayoutMobileReady',
  mixins: [
    ResponsiveMonitor,
  ],
  props: {
    swipeWidth: {
      type: Number,
      required: false,
      default: 70,
    },
    swipeDirection: {
      type: String,
      required: false,
      default: 'right',
    },
    swipeSpeed: {
      type: Number,
      required: false,
      default: 0.25,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    SlideTransition,
  },
  data() {
    return {
      tl: null,
      x: 0,
    };
  },
  computed: {
    sideStyle() {
      const left = this.swipeDirection === 'right' ? `${100 - this.swipeWidth}%` : 0;
      return {
        left,
      };
    },
  },
  methods: {
    openSidebar() {
      this.toggleSidebar('open');
    },
    closeSidebar() {
      this.toggleSidebar('close');
    },
    toggleSidebar(action) {
      const content = this.$refs.content;
      const speed = this.swipeSpeed;

      const moveDirection = this.swipeDirection === 'right' ? '-' : '+';

      const close = 0;
      const open = `${moveDirection}${this.swipeWidth}`;

      switch (action) {
        case 'open':
          this.x = open;
          break;
        case 'close':
          this.x = close;
          break;
        default:
          this.x = this.x === close ? open : close;
          break;
      }

      this.tl.to(content, speed, {
        x: `${this.x}%`,
        ease: Power4.easeInOut,
      });
    },
  },
  mounted() {
    this.tl = new TimelineMax();
    window.Eventus.$on(EVENT.LAYOUT_MOBILE_READY_TOGGLE_SIDEBAR, () => {
      this.toggleSidebar();
    });
  },
  beforeDestroy() {
    window.Eventus.$off(EVENT.LAYOUT_MOBILE_READY_TOGGLE_SIDEBAR);
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/mixins/breakpoints";
  @import '~styles/mixins/gradients';
  @import "~styles/theme/person-colors";

  .nuttrema-layout-mobile-ready {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: visible;
    overflow-y: hidden;
    -ms-overflow-style: none;
    -webkit-font-smoothing: antialiased;

    .nuttrema-layout-mobile-ready__content,
    .nuttrema-layout-mobile-ready__side,
    .nuttrema-layout-mobile-ready__mask {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      box-sizing: border-box;
    }

    .nuttrema-layout-mobile-ready__content {
      z-index: 2;
      background-color: #fff;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 1em 0px;

      .nuttrema-layout-mobile-ready__mask {
        z-index: 5;
        display: none;
        position: fixed;
        overflow-y: hidden;
      }

      .nuttrema-layout-mobile-ready__content__inside {
        flex-grow: 1;
        display: flex;
        min-height: 0;
        align-self: stretch;
        flex-direction: column;
        height: 100vh;

        .nuttrema-layout-mobile-ready__content__inside__top {
          z-index: 10;
          align-self: stretch;
        }
        .nuttrema-layout-mobile-ready__content__inside__center {
          flex: 1 1 auto;
          height: 100%;
          min-width: 0;
          min-height: 0;
          overflow-y: auto;
          position: relative;
          align-self: stretch;
          .nuttrema-layout-mobile-ready__content__inside__center__scroll {
            flex-grow: 1;
            display: flex;
            align-self: stretch;
            flex-direction: column;
          }
        }
        .nuttrema-layout-mobile-ready__content__inside__bottom {
          align-self: stretch;
        }
      }
    }

    .nuttrema-layout-mobile-ready__side {
      // background-color: orange;
      z-index: 2;
    }

    &.is-open {
      .nuttrema-layout-mobile-ready__mask {
        display: block;
      }
    }
  }

  .nuttrema-layout-mobile-ready::-webkit-scrollbar {
    display: none;
  }

  .nuttrema-layout-mobile-ready {

    &.is-for-desktop, &.is-for-big-desktop {

      flex-grow: 1;
      display: flex;
      position: relative;
      align-self: stretch;
      justify-content: space-between;

      .nuttrema-layout-mobile-ready__side {
        position: relative;
        display: flex;
        left: 0 !important;
        min-width: 2em;
      }

      .nuttrema-layout-mobile-ready__mask {
        display: none;
      }

      .nuttrema-layout-mobile-ready__content {
        position: relative;
        display: flex;
        flex-grow: 1;
        align-self: stretch;
        border-radius: 0.5em;
        margin: 0.5em;
        margin-left: 0;
        height: 98vh;
        overflow: hidden;

        .nuttrema-layout-mobile-ready__content__inside {
          height: calc(100vh - 1em);
        }
      }


    } // is-for-desktop, is-for-big-desktop

    &.theme-participant {
      transition: all 0.5s linear;

      &.is-female {
        $bg-color-from: $female-gradient-from;
        $bg-color-to: $female-gradient-to;
        $bg-color-to-mobile: $female-gradient-to-mobile;

        @include gradient-horizontal($bg-color-from, $bg-color-to-mobile, 25%);

        &.is-for-desktop, &.is-for-big-desktop {
          @include gradient-horizontal($bg-color-from, $bg-color-to);
        }
      }

      &.is-male {
        $bg-color-from: $male-gradient-from;
        $bg-color-to: $male-gradient-to;
        $bg-color-to-mobile: $male-gradient-to-mobile;

        @include gradient-horizontal($bg-color-from, $bg-color-to-mobile, 25%);

        &.is-for-desktop, &.is-for-big-desktop {
          @include gradient-horizontal($bg-color-from, $bg-color-to);
        }
      }
    }

    &.theme-landing-default {
      .nuttrema-layout-mobile-ready__side {
        min-width: 0;
      }

      .nuttrema-layout-mobile-ready__content {
        margin: 0;
        box-shadow: none;
        border-radius: 0;
        .nuttrema-layout-mobile-ready__content__inside {
          height: 100vh;
        }
      }

      &.is-for-desktop, &.is-for-big-desktop {}
    }
    // end theme-landing-default

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-mobile-ready.vue